import { ImResponse, messDoorClient, resolve } from 'services/api';

/**
 * SPU_NAME = 1; SPU_ID = 2; SELLER_SPU = 3; SELLER_SKU = 4;
 */
export type KeywordType = 1 | 2 | 3 | 4;

interface ItemListResponse {
  pageInfo: {
    pageNo: number;
    pageSize: number;
    totalCount: number;
  };
  itemList: ItemSelectV2.Item[];
}

type ItemListParams = {
  storeType: 0 | 1 | 2;
  keywordType: KeywordType;
  keyword: string;
  pageNo: number;
  pageSize: number;
  platformStoreScope?: General.StoreScope[];
  tagId?: string[];
  internalItemId?: string[];
  /** Item V4 精确批量查询：SPU ID|PLATFORM|REGION（对齐 perseus queryPolicyItems） */
  spuKey?: string[];
  /** 回显包含已下架商品（对齐 perseus document-task-products：已有关联商品的回显不受上下架影响） */
  includeUnlisted?: boolean;
};

/**
 * 查询商品列表
 * @param params
 */
export function queryItemList(params: ItemListParams) {
  return resolve(
    messDoorClient.post<ImResponse<ItemListResponse>>('/item/v4/items/search', params),
  );
}

export function queryItemListByInternalItemIds(ids: string[], orderBy?: '1' | '2' | '3' | '4') {
  const result: ItemSelectV2.Item[] = [];

  const fetchByPage = (
    page: number,
    resolve: (value: any) => void,
    reject: (reason: any) => void,
  ) => {
    const params = {
      keywordType: 1,
      keyword: '',
      internalItemId: ids,
      pageNo: page,
      pageSize: 100,
      platformStoreScope: [],
      tagId: [],
      orderBy: Number(orderBy),
    };

    messDoorClient
      .post<ImResponse<ItemListResponse>>('/item/v4/items/search', params)
      .then((res) => {
        const { itemList, pageInfo } = res.data.data;
        result.push(...itemList);
        if (pageInfo.pageNo * 100 < pageInfo.totalCount) {
          fetchByPage(pageInfo.pageNo + 1, resolve, reject);
        } else {
          resolve({
            itemList: result,
            pageInfo,
          });
        }
      })
      .catch(reject);
  };
  return new Promise((resolve, reject) => {
    return fetchByPage(1, resolve, reject);
  });
}

export function queryItemListByKeyword({
  keyword,
  keywordType,
  platformStoreScope,
}: {
  keyword: string;
  keywordType: KeywordType;
  platformStoreScope?: General.StoreScope[];
}) {
  const params = {
    keywordType,
    keyword,
    pageNo: 1,
    pageSize: 9999,
    platformStoreScope: platformStoreScope || [],
    tagId: [],
  };
  return resolve(
    messDoorClient.post<ImResponse<ItemListResponse>>('/item/v4/items/search', params),
  );
}

export function queryItemListBySellerSku(sellerSku: string) {
  const params = {
    keywordType: 4,
    keyword: sellerSku,
    pageNo: 1,
    pageSize: 9999,
    platformStoreScope: [],
    tagId: [],
  };
  return resolve(
    messDoorClient.post<ImResponse<ItemListResponse>>('/item/v4/items/search', params),
  );
}
